import { Badge } from 'components/atoms';
import React from 'react';

const BadgeContractPrice = ({ children }) => (
  <Badge className="badge badge--contract-price">{children}</Badge>
);

export default BadgeContractPrice;
